import { customerBaseApi } from "@/react/services/api";

const sipTrunkBaseUrl = "trunk-config";
const TRUNK_GATEWAYS = "TRUNK_GATEWAYS";
const trunkGatewayTag = ({ trunkId }) => `TRUNK_GATEWAY_${trunkId}`;

export const sipTrunkApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getSipTrunks: build.query({
      query: () => ({
        url: sipTrunkBaseUrl,
        method: "GET",
      }),
      providesTags: [TRUNK_GATEWAYS],
    }),
    getSipTrunkById: build.query({
      query: ({ trunkId }) => ({
        url: `${sipTrunkBaseUrl}/${trunkId}`,
        method: "GET",
      }),
      providesTags: ({ trunkId }) => [trunkGatewayTag({ trunkId })],
    }),
    createSipTrunk: build.mutation({
      query: ({ trunkGateway }) => ({
        url: sipTrunkBaseUrl,
        method: "POST",
        body: trunkGateway,
      }),
      invalidatesTags: [TRUNK_GATEWAYS],
    }),
    updateSipTrunk: build.mutation({
      query: ({ trunkId, trunkGateway }) => ({
        url: `${sipTrunkBaseUrl}/${trunkId}`,
        method: "PUT",
        body: trunkGateway,
      }),
      invalidatesTags: ({ trunkId }) => [
        TRUNK_GATEWAYS,
        trunkGatewayTag({ trunkId }),
      ],
    }),
    deleteSipTrunk: build.mutation({
      query: ({ trunkId }) => ({
        url: `${sipTrunkBaseUrl}/${trunkId}`,
        method: "DELETE",
      }),
      invalidatesTags: ({ trunkId }) => [
        TRUNK_GATEWAYS,
        trunkGatewayTag({ trunkId }),
      ],
    }),
  }),
});

export const {
  useGetSipTrunksQuery,
  useGetSipTrunkByIdQuery,
  useCreateSipTrunkMutation,
  useUpdateSipTrunkMutation,
  useDeleteSipTrunkMutation,
} = sipTrunkApi;
